import { NgModule, Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicModalModule } from '../../shared/modules/modals/basic-modal/basic-modal.module';
import { LoadingModule } from '../../shared/modules/loading/loading.module';
import { ModalsEvent } from '../../shared/event-listeners/modals/modals.event';
import { ButtonModule } from '../../shared/modules/button/button.module';

@Component({
  selector: 'app-image-text-simple-modal',
  templateUrl: 'image-text-simple-modal.component.html',
  styleUrls: ['image-text-simple-modal.component.scss'],
})
export class ImageTextSimpleModalComponent implements OnInit {

  modalStatus: any = { open: false };
  @Input() title = '';
  @Input() img = '';
  loading: boolean = true;

  constructor( private  modalEvets: ModalsEvent) {
  }

  ngOnInit() {
    this.modalEvets.currentModalImgTextSimple.subscribe( (res: any) => {
      this.modalStatus = { open: res?.open };
    });
  }

  closeModal() {
    this.modalStatus = { close: true };
  }

}

@NgModule({
  declarations: [ImageTextSimpleModalComponent],
  exports: [ImageTextSimpleModalComponent],
  imports: [
    CommonModule,
    BasicModalModule,
    LoadingModule,
    ButtonModule
  ]
})
export class ImageTextSimpleModalModule { }
